import { useEffect, useMemo, useState } from 'react';

import { Box, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';

import { PermissoesModulosAutocomplete } from 'pages/cadastro/permissoes/components/form/modulos/PermissoesModulosAutocomplete';
import { PermissoesModulosMenu } from 'pages/cadastro/permissoes/components/form/modulos/PermissoesModulosMenu';
import { PermissoesModulosOpcoes } from 'pages/cadastro/permissoes/components/form/modulos/PermissoesModulosOpcoes';
import { PermissoesPanelTitle } from 'pages/cadastro/permissoes/components/form/PermissoesPanelTitle';
import { PermissoesProps } from 'pages/cadastro/permissoes/types';
import { getEnabledCount } from 'pages/cadastro/permissoes/utils';

export function PermissoesModulosPanel() {
    const { values } = useFormikContext<PermissoesProps>();
    const modules = values.grupoUsuarioRecursoPermissoes;
    const [selectedModuleId, setSelectedModuleId] = useState<number | null>(null);
    const [permSearch, setPermSearch] = useState('');
    const totalEnabled = useMemo(() => modules.reduce((acc, m) => acc + getEnabledCount(m), 0), [modules]);
    const totalPerms = useMemo(() => modules.reduce((acc, m) => acc + m.permissoes.length, 0), [modules]);
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
        if (modules.length > 0 && selectedModuleId === null) {
            setSelectedModuleId(modules[0].idRecurso);
        }
    }, [modules, selectedModuleId]);

    return (
        <Paper elevation={2} sx={{ overflow: 'hidden', borderRadius: 1 }}>
            <PermissoesPanelTitle
                title="Módulos"
                extraContent={
                    <Typography variant="body2" sx={{ color: 'common.white', fontWeight: 500 }}>
                        {totalEnabled}/{totalPerms} permissões ativas
                    </Typography>
                }
            />

            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, height: { xs: 700, md: 540 } }}>
                {isMdUp && (
                    <PermissoesModulosMenu
                        selectedModuleId={selectedModuleId}
                        setSelectedModuleId={setSelectedModuleId}
                        setPermSearch={setPermSearch}
                    />
                )}

                {!isMdUp && (
                    <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                        <PermissoesModulosAutocomplete
                            setSelectedModuleId={setSelectedModuleId}
                            setPermSearch={setPermSearch}
                            selectedModuleId={selectedModuleId}
                        />
                    </Box>
                )}

                {selectedModuleId && (
                    <PermissoesModulosOpcoes selectedModuleId={selectedModuleId} permSearch={permSearch} setPermSearch={setPermSearch} />
                )}
            </Box>
        </Paper>
    );
}
